angular.module("avlib").filter('avInteger', ["$filter", function ($filter) {

	var groupDigits = function(value){
		if (value == null || value == ""){
			return value;
		}else{
			if (value.length > 3){
				var currentGroup = value.substr(value.length-3);
				var nextInput = value.substr(0, value.length-3);
				return groupDigits(nextInput) + "." + currentGroup;
			}else{
				return value;
			}
		}
	};

	return function(value){
		if (value == null){
			return "";
		}

		if (isNaN(value)){
			value = ""+value;
			try{
				value = value.parseInt();
			}catch(e){
				return null;
			}
		}

		value = value.toFixed(0);
		value = value.replace(".", ",");

		// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
		value = groupDigits(value);

		return value;
	};
}]);
